import { createTheme, useMediaQuery } from "@mui/material";

export default function useDesktopSize() {
  const theme = createTheme({
    breakpoints: {
      values: {
        xs: 280,
        sm: 380,
        md: 960,
        lg: 1200,
        xl: 1536
      }
    }
  });
  return useMediaQuery(theme.breakpoints.up("md"));
}
